import { defaultTheme, dark, rhino } from '@rhinofi/dvf-shared-ui/lib/theme/colors'
import type { DefaultTheme } from 'styled-components'
import { themeAssets } from './assets/assets'
import type { ThemeName } from './store/slices/types/PortalReducerState'

export const themes: Record<ThemeName, DefaultTheme> = {
  dark: {
    theme: 'dark',
    assets: themeAssets.dark,
    ...defaultTheme,
    ...dark,
  },
  rhino: {
    theme: 'rhino',
    assets: themeAssets.rhino,
    ...defaultTheme,
    defaultFont: "Geist, 'PT Sans', sans-serif",
    ...rhino,
  },
}
